import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule, DecimalPipe, DatePipe, NgFor, NgIf } from '@angular/common';
import { InvoiceserviceService } from '../../../../Services/invoiceservice.service';

@Component({
  selector: 'app-sale-report',
  standalone: true,
  imports: [CommonModule, DecimalPipe, DatePipe, NgFor, NgIf],
  templateUrl: './sale-report.component.html',
  styleUrl: './sale-report.component.css'
})
export class SaleReportComponent implements OnChanges {
  @Input() firmId: any;
  @Input() fromDate: any;
  @Input() toDate: any;

  sales: any[] = [];
  loading: boolean = false;

  // accordion
  accordionState = {
    sale: false,
  };

  saleSummary: any = {
    title: 'Sale Details',
    amount_in: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
    amount_out: { cash: 0, bank: 0, card: 0, online: 0, disc: 0, total: 0 },
    total: 0,
    amount_received: 0,
    balance_due: 0,
    metal_billed: 0,
    metal_received: 0,
    metal_settled: 0,
    metal_due: 0
  };

  chips = [
    { label: 'Sale Amt', value: '0.00' },
    { label: 'Recd Amt', value: '0.00' },
    { label: 'Due Amt', value: '0.00' },
    { label: 'Metal Billed', value: '0.00' },
    { label: 'Metal Recd', value: '0.00' },
    { label: 'Metal Conv', value: '0.00' },
    { label: 'Metal Due', value: '0.00' },
  ];

  constructor(private invoiceService: InvoiceserviceService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['firmId'] || changes['fromDate'] || changes['toDate']) {
      this.loadReport();
    }
  }

  toggleAccordion(type: 'sale') {
    this.accordionState[type] = !this.accordionState[type];
  }

  loadReport() {
    const params = {
      firm_id: this.firmId,
      from_date: this.fromDate,
      to_date: this.toDate
    };

    this.loading = true;
    this.invoiceService.getSaleReport(params).subscribe({
      next: (res: any) => {
        this.sales = res.data || [];
        this.calculateSummary();
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading sale report', err);
        this.loading = false;
      }
    });
  }

  calculateSummary() {
    let totalSale = 0;
    let totalReceived = 0;
    let totalDue = 0;
    let metalBilled = 0;
    let metalRecd = 0;
    let metalSettled = 0;
    let metalDue = 0;

    this.sales.forEach(s => {
      totalSale += (s.total_amount || 0);
      totalReceived += (s.amount_paid || 0);
      totalDue += (s.balance_due || 0);
      metalBilled += (s.total_metal_billed || 0);
      metalRecd += (s.metal_received || 0);
      metalSettled += (s.metal_settled || 0);
      metalDue += (s.metal_due || 0);
    });

    this.saleSummary.amount_in.total = totalSale;
    this.saleSummary.total = totalSale;
    this.saleSummary.amount_received = totalReceived;
    this.saleSummary.balance_due = totalDue;
    this.saleSummary.metal_billed = metalBilled;
    this.saleSummary.metal_received = metalRecd;
    this.saleSummary.metal_settled = metalSettled;
    this.saleSummary.metal_due = metalDue;
    this.chips = [
      { label: 'Sale Amt', value: totalSale.toFixed(2) },
      { label: 'Recd Amt', value: totalReceived.toFixed(2) },
      { label: 'Due Amt', value: totalDue.toFixed(2) },
      { label: 'Metal Billed', value: metalBilled.toFixed(2) },
      { label: 'Metal Recd', value: metalRecd.toFixed(2) },
      { label: 'Metal Conv', value: metalSettled.toFixed(2) },
      { label: 'Metal Due', value: metalDue.toFixed(2) },
    ];
  }
}
